export default __webpack_public_path__ + "static/unlock-business-b61662e01e419ce9fed1ac26245b47d8.svg";